<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Facturación</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Ventas por Producto</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-tags</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Datos Agrupados!</div>
          <div class="caption grey--text px-4 mb-6">El consolidado de facturación por producto ha sido procesado exitosamente.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchInvoicedProducts} from '@/api/reports'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: "ExportProductInvoice",
  props: ['filter', 'options', 'disabled'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      items: [],
      dataReady: false,
      labels: { 
        product__sku: { title: 'Código' },
        product__name: { title: 'Nombre' },
        product__family__name: { title: 'Familia' },
        product__line__name: { title: 'Linea' },
        total: { title: 'Neto' },
      },
      csvTitle: `export_invoices_by_product_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods: {
    async fetch() {
      //Arreglando variables de fecha en caso de ser null
      if(!this.filter.created_after) this.filter.created_after=''
      if(!this.filter.created_before) this.filter.created_before=''
      if(!this.filter.seller) this.filter.seller=''
      const {sortBy, sortDesc,page, itemsPerPage }=this.options
      let  sort = (sortDesc[0] ? '-'+sortBy[0] : sortBy[0])
      if (!sort||!sortBy[0]) sort = 'product__sku'
      const query=`page=1&ordering=${sort}&emited_after=${this.filter.created_after}&emited_before=${this.filter.created_before}&dte__customer__seller__id=${this.filter.seller}&dte__tipo=30`
      
      await fetchInvoicedProducts(query)
        .then((res) => {
          this.items = res.results.map(i => ({
            ...i,
            product__name: i.product__name ? i.product__name.replaceAll("\"", "") : '',
            qty: numeral(i.qty).format('0'),
            total: numeral(i.total).format('0')
          }))
          this.dataReady = true
        })
        .catch((err) => notifications.showError('Error cargando documentos: ' + err))
        .finally(() => this.loading = false)
    },
    handleSuccess(val) {
      notifications.showSuccess('Facturación Exportada')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Facturación')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>